module.exports = __webpack_public_path__ + "h5/img/andy.0f61a67a.jpg";